import { Layout, StateColor as StateColorComponent } from "components"
export const StateColor = () => {
 return (
  <Layout>
   <StateColorComponent />
  </Layout>
 )
}
